import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

type TransferCategory = {
  name: string;
  description: string;
};

type TransferCategoryCardProps = {
  category: TransferCategory;
  onCategoryChange: (field: keyof TransferCategory, value: string | undefined) => void;
  onRemove: () => void;
};

const TransferCategoryCard = ({
  category,
  onCategoryChange,
  onRemove,
}: TransferCategoryCardProps) => {
  return (
    <div className="cursor-pointer rounded-md border border-l border-gray-200 bg-white p-4 shadow-sm transition-all duration-200 ease-in-out hover:scale-[1.02] hover:border-l-4 hover:border-l-blue-500 hover:shadow-md">
      <div className="flex items-start justify-between gap-6">
        <div className="flex-1">
          <Input
            value={category.name}
            onChange={(e) => onCategoryChange("name", e.target.value)}
            placeholder="Nombre de la categoria (ej: Urgente, Seguimiento)"
            className="mb-3 border-gray-200 bg-gray-50 font-semibold hover:border-gray-300 hover:bg-white focus-visible:bg-white focus-visible:ring-blue-500"
          />
          <Textarea
            value={category.description}
            onChange={(e) => onCategoryChange("description", e.target.value)}
            placeholder="Descripcion de cuando usar esta categoria (ej: Cliente listo para cerrar negocio)"
            rows={3}
            className="resize-y border-gray-200 bg-gray-50 text-sm hover:border-gray-300 hover:bg-white focus-visible:bg-white focus-visible:ring-blue-500"
          />
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={onRemove}
          aria-label="Eliminar categoria"
          className="text-red-500 hover:bg-red-50 hover:text-red-600"
        >
          <Trash2 className="size-4" />
        </Button>
      </div>
    </div>
  );
};

export default TransferCategoryCard;
